/**
 * Normaliza un nombre para comparación: quita diacríticos, baja a minúsculas,
 * colapsa espacios y elimina sufijo numérico tipo "Tacos 2".
 * @param {string} name Nombre original a normalizar.
 * @returns {string} Nombre normalizado para comparaciones de duplicados.
 */
export const normalize = (name: string): string => {
  if (!name) return '';
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\s+\d+\s*$/, '')
    .trim();
};

/**
 * Compara dos precios y decide si están "cerca" según un ratio relativo
 * (|a - b| / max(a, b, 1) <= tolerance). Default 10%.
 * @param {number} a Primer precio.
 * @param {number} b Segundo precio.
 * @param {number} tolerance Ratio máximo aceptable (default 0.1).
 * @returns {boolean} True si los precios se consideran equivalentes.
 */
export const isPriceClose = (a: number, b: number, tolerance: number = 0.1): boolean => {
  const diff = Math.abs(a - b);
  const denom = Math.max(a, b, 1);
  return diff / denom <= tolerance;
};
